import { Tooltip } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { useSelector } from "react-redux";
import { palette } from "../../theme/palette";
import { routeSelector } from "../../reducers/matrixProfile/selectors";

const useStyles = makeStyles({
  container: {
    width: "30px",
    height: "30px",
    background: "white",
    borderRadius: "4px",
    boxShadow: `0px 2px 3px ${palette.typography.black.high}`,
  },
  label: {
    margin: "2px",
    width: "26px",
    height: "26px",
    lineHeight: "26px",
    fontSize: "0.75rem",
    textAlign: "center",
    borderRadius: "0.125rem",
    fontWeight: "bold",
    color: "white",
    cursor: "pointer",
    position: "relative",
  },
});

export const RouteLabel = ({ routeCode, disableTooltip = false }) => {
  const styles = useStyles();
  const route = useSelector(routeSelector(routeCode));

  if (!routeCode) disableTooltip = true;
  return (
    <Tooltip
      disableFocusListener={disableTooltip}
      disableHoverListener={disableTooltip}
      disableTouchListener={disableTooltip}
      placement={"left"}
      enterDelay={500}
      enterNextDelay={500}
      title={`ROUTE WAVE: ${route?.plannedReadyTimeAsString || "FINAL"}`}
    >
      <div className={styles.container}>
        <div
          style={{
            background: route?.colour || "black",
            color: route?.textColour || palette.typography.white.high,
          }}
          className={styles.label}
        >
          {routeCode || "?"}
        </div>
      </div>
    </Tooltip>
  );
};
